module.exports = __webpack_public_path__ + "img/bg_plan_type_light.6d5112db.jpg";